export default "__VITE_ASSET__BLz2hPBo__"